import React from 'react';
import { Link } from 'react-router-dom';
import './PurchaseCredits.css';
import { FormattedMessage } from 'react-intl';
import { Result, Icon } from 'antd';
import { viaRequestShape } from '../../../utility/via-util';
import routeLocations from '../../../utility/route-locations';

/**
 * Displays the result of the purchase attempt.
 * @param {object} props The react props
 * @param {object} props.purchaseRequest A via request object for the attempted purchase.
 */
export default function PurchaseResult({ purchaseRequest }) {
  const { isLoading, error, payload } = purchaseRequest;

  // Render - The request is pending.
  if (isLoading) {
    return (
      <Result
        icon={<Icon type="loading" />}
        title={<FormattedMessage id="purchasePending" />}
        subTitle={<FormattedMessage id="purchasePendingDesc" />}
      />
    );
  }

  // Render - The request has failed.
  if (error) {
    return (
      <Result
        icon={<Icon type="close-circle" theme="twoTone" twoToneColor="red" />}
        title={<FormattedMessage id="purchaseError" />}
        subTitle={(
          <div>
            <ul>{error.errors && error.errors.map(errMsg => <li key={errMsg}>{errMsg}</li>)}</ul>
          </div>
        )}
        extra={<Link to={routeLocations.dashboard}><FormattedMessage id="gotoDashboard" /></Link>}
      />
    );
  }

  // Render - The request has succeded.
  return (
    <Result
      icon={<Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />}
      title={<FormattedMessage id="purchaseSuccess" />}
      subTitle={(
        <FormattedMessage id="purchaseRef" values={{ purchaseRef: <div className="purchase-reference">{payload.purchaseId}</div> }} />
      )}
      extra={<Link to={routeLocations.dashboard}><FormattedMessage id="gotoDashboard" /></Link>}
    />
  );
}

PurchaseResult.propTypes = {
  purchaseRequest: viaRequestShape.isRequired,
};
